// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var PlanTier = function (x) {
    return x;
};
var tsBridgePlanTier = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("PlanTier")("__brandPlanTier"));
    }
};
var writePlanTier = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showPlanTier = Data_Show.showString;
var readPlanTier = Simple_JSON.readString;
var ordPlanTier = Data_Ord.ordString;
var newtypePlanTier = {
    Coercible0: function () {
        return undefined;
    }
};
var makePlanTier = PlanTier;
var eqPlanTier = Data_Eq.eqString;
export {
    PlanTier,
    makePlanTier,
    unwrap,
    newtypePlanTier,
    eqPlanTier,
    ordPlanTier,
    showPlanTier,
    readPlanTier,
    writePlanTier,
    tsBridgePlanTier
};
//# sourceMappingURL=index.js.map
